import { CreatePetProfile } from "../../features/account_settings/components/pets/CreatePetProfile";

const CreatePetPage = () => {
  return <CreatePetProfile />
};
export default CreatePetPage;